import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { GenericValue, HisGenericValueService } from 'hisng';

@Component({
    selector: 'res-yes-no-plam',
    templateUrl: './yes-no-plam.component.html'
})
export class YesNoPlamComponent implements OnInit {
    @Input() editMode = true;
    @Input() ddKey: string;
    @Input() label: string = undefined;
    @Input() showLabelTop = false;
    @Input() value: GenericValue;
    @Input() styleClass: string;
    @Output() valueChange: EventEmitter<GenericValue> = new EventEmitter();
    @Output() valueCleared: EventEmitter<any> = new EventEmitter();

    private booleanTypes: GenericValue[];
    public filteredBooleanTypes: any[] = [];

    constructor(private genericValueService: HisGenericValueService) { }

    /* Component ngOnInit() */
    ngOnInit() {
        this.booleanTypes = this.genericValueService.getBooleanTypes();
    }

    /** completeMethod implementation boolean types */
    public filterBooleanTypes(event: { query: string }) {
        this.filteredBooleanTypes = [];
        for (let booleanType of this.booleanTypes) {
            if (booleanType.text.toLowerCase().includes(event.query.toLowerCase())) {
                this.filteredBooleanTypes.push(booleanType);
            }
        }
    }

    /** Selection has changed */
    public onSelect($event: GenericValue) {
        // console.log('onSelect(): $event =', $event, '(type =', (typeof $event), ')');
        this.valueChange.emit($event);
    }

    /** Selection has been deleted */
    public onClear() {
        // console.log('onClear()');
        this.valueCleared.emit();
    }
}
